import type { ResourceConfig } from "../types";

/**
 * 知识条目权限配置 (Spec 056)
 *
 * 合并了原 topics + articles，实现完整的审核 → 认领 → 编辑 → 发布流程
 */
export const knowledgeEntryConfig = {
  displayName: "知识条目",
  category: "knowledge",
  permissions: {
    "read:all": {
      label: "查看所有知识条目",
      description: "可以查看所有状态的知识条目",
    },
    "review:all": {
      label: "审核知识条目",
      description: "可以审核待审核的知识条目（通过/删除）",
    },
    "claim:all": {
      label: "认领知识条目",
      description: "可以认领已审核待认领的知识条目",
    },
    "write:all": {
      label: "编辑所有知识条目",
      description: "可以编辑任何人认领的知识条目",
    },
    "write:assigned": {
      label: "编辑自己的知识条目",
      description: "只能编辑自己认领的知识条目",
    },
    "publish:all": {
      label: "发布知识条目",
      description: "可以将草稿状态的知识条目发布",
    },
    "delete:all": {
      label: "删除知识条目",
      description: "可以硬删除知识条目",
    },
    "dedup:run": {
      label: "运行知识条目查重",
      description: "可以运行有界的知识条目向量查重批次",
    },
  },
  scopeStrategy: "byDirectStaff",
  navigation: {
    path: "/knowledge",
    label: "知识库",
    icon: "BookOpen" as const,
    requiredPermissions: ["read:all"] as const,
    order: 60,
    // 学员直接进入文章列表，其他角色进入管理面板
    pathByRole: {
      student: "/knowledge/articles",
    },
  },
} satisfies ResourceConfig;
